import styled from 'styled-components/macro';

import ResponsiveContainer from '../../../layout/ResponsiveContainer';

import { NavLink } from 'react-router-dom';

const Wrapper = styled(ResponsiveContainer)`
  justify-content: space-between;
  flex-wrap: wrap;
`;

const Link = styled(NavLink)`
  text-decoration: none;
`;

export { Wrapper, Link };
